





















import { Component, Vue, Prop, Provide, PropSync } from 'vue-property-decorator';
import { makeReactiveProperty } from '@/utils/utils';

@Component
export default class SNavMenu extends Vue {
  @Prop(Boolean) public router?: boolean;
  @Prop(Boolean) public side?: boolean;
  @Prop(Boolean) public expandable?: boolean;
  @Prop({ type: Boolean, default: false }) public burger!: boolean;
  @PropSync('expanded', { type: Boolean, default: false }) public expandedSync!: boolean;
  @Prop({ type: Boolean, default: false }) public main!: boolean;
  @Prop({ type: Boolean, default: false }) public fixed!: boolean;
  @Prop({ type: String, default: 'blue' }) public color!: 'green' | 'blue';

  public reactiveProps: { expanded: boolean } = { expanded: false };

  @Provide('sNavMenu') public sNavMenu = this;

  private pushDown = false;
  private pushRight = false;

  public created() {
    makeReactiveProperty(this, this.reactiveProps, 'expandedSync', 'expanded');
  }

  public mounted() {
    if (this.main) {
      const root = (this.$root.$el as HTMLElement);
      if (this.side) {
        if (root.dataset.nav === 'top') this.pushDown = true;
        root.dataset.nav = 'side';
        this.addPadding(false);
      } else {
        if (root.dataset.nav === 'side') this.pushRight = true;
        root.dataset.nav = 'top';
        this.addPadding(true);
      }
    }
  }

  public destroyed() {
    if (!this.main) return;
    const root = (this.$root.$el as HTMLElement);
    if (this.side) {
      root.style.paddingLeft = '0px';
    } else {
      root.style.paddingTop = '0px';
    }
  }

  public toggleExpand() {
    this.addPadding(!this.side, !this.expandedSync);
    this.expandedSync = !this.expandedSync;
  }

  public addPadding(top = true, expanded = this.expandedSync) {
    if (!this.main) return;
    const root = (this.$root.$el as HTMLElement);
    let width: string | number = expanded ? 250 : 50;
    width = `${width}px`;
    if (top) {
      root.style.paddingTop = width;
    } else {
      root.style.paddingLeft = width;
    }
  }
}
